import { COMPONENT_KEY } from '@web-platform/shared-universal-constants/src/componentKeys';
import {
  QUERY_RESPONSE_RECEIVED,
  MUTATION_RESPONSE_RECEIVED,
  MUTATION_REQUIRED,
} from '@web-platform/shared-universal-constants/src/network';
import { RADAR_CREATE_SESSIONS } from '@web-platform/shared-universal-types/src/network/requestTypes';

import { USER_REQUESTED_SEARCH } from '../../../actions/searchControls';

import type { Action } from '@web-platform/shared-universal-types/src/redux/banana/actions/actions-banana-types';
import type {
  CombinedComponentKeysResultState,
  CombinedComponentKeyState,
} from '@web-platform/shared-universal-types/src/redux/banana/state/shared/combinedComponentKeys';

export const INITIAL_STATE: CombinedComponentKeysResultState = {
  content: [],
  isLoading: true,
};

const COMBINED_RESULTS_KEY = {
  accommodations: 'accommodations',
  carHire: 'carHire',
  itineraries: 'itineraries',
  results: 'results',
} as const;

export default function (
  state: CombinedComponentKeysResultState = INITIAL_STATE,
  action: Action,
): CombinedComponentKeysResultState {
  switch (action.type) {
    case MUTATION_RESPONSE_RECEIVED:
    case QUERY_RESPONSE_RECEIVED: {
      const { payload } = action;
      const { body: radarResponseBody, error } = payload.response;

      if (payload.type === RADAR_CREATE_SESSIONS) {
        if (error) {
          return {
            ...INITIAL_STATE,
            isLoading: false,
          };
        }
        // We only need to know what fields that Radar response contains but don't need to wait the full data complete
        if (!error) {
          const combinedComponentKeys = Object.keys(radarResponseBody).filter(
            (key) =>
              // @ts-expect-error The `key` must be one of the field in the response but its type is string from Object.keys type inference ,it does not impact anything here which just validate whether the value exist.
              (key in COMPONENT_KEY || key in COMBINED_RESULTS_KEY) && radarResponseBody[key],
          );

          if (
            combinedComponentKeys.includes(COMBINED_RESULTS_KEY.accommodations) ||
            combinedComponentKeys.includes(COMBINED_RESULTS_KEY.carHire) ||
            combinedComponentKeys.includes(COMBINED_RESULTS_KEY.itineraries) ||
            combinedComponentKeys.includes(COMBINED_RESULTS_KEY.results)
          ) {
            combinedComponentKeys.push(COMPONENT_KEY.combinedResults);
          }
          return {
            content: combinedComponentKeys,
            isLoading: false,
          } as CombinedComponentKeysResultState;
        }
      }

      return state;
    }

    case USER_REQUESTED_SEARCH: {
      return {
        ...state,
        isLoading: action.payload.searched,
      };
    }

    // reset the CombinedComponentKeys after trigger a new mutation to avoid it shows previous result page shortly and cause issues.
    case MUTATION_REQUIRED:
      if (action.payload.type === RADAR_CREATE_SESSIONS) {
        return INITIAL_STATE;
      }
      return state;

    default:
      return state;
  }
}

export const getCombinedComponentKeys = (
  state: CombinedComponentKeysResultState,
): CombinedComponentKeyState[] => state.content;

export const isLoadingCombinedComponentKeys = (state: CombinedComponentKeysResultState): boolean =>
  state.isLoading;
